import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useIntercom } from "react-use-intercom";
import { StepComponentProps } from "../step-config-file/types";
import { useState } from "react";

interface InfoCardData {
  title: string;
  copy: string | React.ReactNode;
  showExploreButton?: boolean;
  showSpeakToExpertButton?: boolean;
}

export const InfoCard = (props: StepComponentProps) => {
  const { showNewMessage } = useIntercom();
  const cardData = props.data as InfoCardData;
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleExit = () => {
    // Navigate to explore phase (step 11) with fly animation
    const exploreStepId = 11;
    const currentStepId = props.id;

    if (currentStepId < exploreStepId) {
      // Hide the card immediately
      setIsTransitioning(true);

      // Fly to step 11 coordinates
      props.moveToNextLocation({
        longitude: 146.16271,
        latitude: -18.65488,
        geocoder_attributes: {},
        zoomLevel: 13,
        targetStep: exploreStepId,
      });

      // Jump directly to step 11 after the flyTo animation completes (3000ms)
      setTimeout(() => {
        props.goToStep(exploreStepId);
      }, 2500);
    }
  };

  const handleNext = () => {
    if (props.nextCoordinates && props.zoomLevel) {
      props.moveToNextLocation({
        ...props.nextCoordinates,
        geocoder_attributes: {},
        zoomLevel: props.zoomLevel,
        targetStep: props.id + 1, // Pass the target step (current + 1)
      });
    }
    props.nextStep();
  };

  const handleBack = () => {
    if (props.previousCoordinates && props.previousZoomLevel) {
      props.moveToNextLocation({
        ...props.previousCoordinates,
        geocoder_attributes: {},
        zoomLevel: props.previousZoomLevel,
        targetStep: props.id - 1, // Pass the target step (current - 1)
      });
    }
    props.backStep();
  };

  const handleSpeakToExpert = () => {
    showNewMessage("I'd like to learn more about First Floor Elevation Insights");
  };

  // Hide card during transition to step 11
  if (isTransitioning) {
    return null;
  }

  return (
    <Card
      style={{
        border: "none",
        boxShadow: "none",
        width: "560px",
        maxHeight: "100%",
        display: "flex",
        flexDirection: "column",
        alignSelf: "self-end",
        position: "fixed",
        left: "35%",
        bottom: "100px",
        borderRadius: "16px",
        zIndex: 1000,
      }}
    >
      <CardHeader
        title={cardData.title}
        titleTypographyProps={{ variant: "h5" }}
        action={
          <IconButton aria-label="close" onClick={handleExit}>
            <CloseIcon />
          </IconButton>
        }
      />
      <CardContent
        sx={{
          padding: "16px !important",
        }}
      >
        {typeof cardData.copy === "string" ? (
          <Typography variant="body1" paragraph>
            {cardData.copy}
          </Typography>
        ) : (
          cardData.copy
        )}
      </CardContent>
      <CardActions sx={{ justifyContent: "space-between" }} >
          {props.id === 1 ? (
            <Button size="small" color="error" onClick={handleExit}>
              Exit
            </Button>
          ) : props.id > 1 ? (
            <Button size="small" color="primary" onClick={handleBack}>
              Back
            </Button>
          ) : null}
            {cardData.showSpeakToExpertButton && (
           <Button
                variant="contained"
                size="small"
                onClick={handleSpeakToExpert}
                color="secondary"
              >
                    SPEAK TO AN EXPERT
              </Button>
          )}
          {cardData.showExploreButton ? (
            <Button size="small" color="primary" onClick={handleNext}>
              Explore
            </Button>
          ) : (
            <Button size="small" color="primary" onClick={handleNext}>
              Next
            </Button>
          )}
      </CardActions>
    </Card>
  );
};
